import { JSX } from 'preact';

import cx from 'clsx';
import { PaylinkState } from '@paylink/types';
import { AlertIcon } from '@paylink/icons';

import styles from './PaymentStatus.module.scss';

export interface IPaymentStatusProps {
	state: PaylinkState.FAILED | PaylinkState.ERRORED;
}

const iconProps = {
	height: 40,
	width: 40,
};

const STATE_CONFIG: Record<
	PaylinkState.FAILED | PaylinkState.ERRORED,
	{
		title: string;
		message: string;
		iconClass: string;
		icon: JSX.Element;
	}
> = {
	[PaylinkState.FAILED]: {
		title: 'Payment Failed',
		message: 'Something went wrong with this payment. Please try again later.',
		iconClass: 'bg-error',
		icon: <AlertIcon {...iconProps} />,
	},
	[PaylinkState.ERRORED]: {
		title: 'Something Went Wrong',
		message:
			'An error occurred with this payment link. Please try again later or contact support.',
		iconClass: 'bg-error',
		icon: <AlertIcon {...iconProps} />,
	},
};

const PaymentStatus = ({ state }: IPaymentStatusProps) => {
	const config = STATE_CONFIG[state as keyof typeof STATE_CONFIG];

	if (!config) return null;

	return (
		<div
			className={cx(
				'd-flex justify-center items-center p4 bg-tertiary',
				styles.wrapper,
			)}
		>
			<div
				className={cx(
					'width100 border-radius3 overflow-hidden card-shadow1 d-flex flex-column items-center gap4 bg-white px8 pb8',
					styles.card,
				)}
			>
				<div
					className={cx(
						'border-radius-full d-flex justify-center items-center',
						styles.iconCircle,
						config.iconClass,
					)}
				>
					{config.icon}
				</div>
				<p className="h3 bolder dark3 m0 center">{config.title}</p>
				<p className="h5 grey6 m0 center lh3">{config.message}</p>
			</div>
		</div>
	);
};

export default PaymentStatus;
